import React from 'react'
import { Text } from 'front-end/src/components'
import { Link } from '../../../../components/common/link/Link'
import { linkBuilder } from 'shared/linkBuilder'
import { Trans } from '@lingui/macro'
import { useLoginContext } from 'front-end/src/pages/auth/login/LoginContext'
import { observer } from 'mobx-react'

export const ForgotPasswordLink: React.FC = observer(() => {
  const { userIdentity } = useLoginContext()

  return (
    <Text mt="32px">
      <Link
        to={linkBuilder.resetPassword(userIdentity)}
        dataTest="ForgotPasswordLink"
      >
        <Trans>Forgot your password?</Trans>
      </Link>
    </Text>
  )
})

ForgotPasswordLink.displayName = 'ForgotPasswordLink'
